export default __webpack_public_path__ + "static/media/bg-shape-crooked.5cefd6fb.png";